import {Component, Inject, OnInit,  Renderer2, ViewChild, signal} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule, Location } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MasterdataService } from 'src/app/home/services/masterdata.service';


@Component({
  selector: 'app-add-master-product',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './add-master-product.component.html',
  styleUrls: ['./add-master-product.component.scss', '../../../../app.component.scss', '../../../../shared/base-modal.style.scss']

})
export class AddMasterProductComponent {

  public propData: any;
  public regions: any;
  public selectedRegion: any = {id: "", value: ""};
  public isEdited: boolean = false;
  public nameTxt: string;
  public search: any

  constructor(
    public dialogRef: MatDialogRef<AddMasterProductComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private masterdataService: MasterdataService,
    private renderer: Renderer2
  ) {
    if(data){
      this.propData = data;
      this.regions = this.propData.regions;
    }
  }

  ngOnInit(): void {
  if (this.propData && this.propData.type === "edit") {
    console.log(this.propData, " propData");

    if (this.propData.regions) {
      console.log(this.propData.regions, "regions"); 

      let regions = this.propData.regions;
      let regionIdToFind = this.propData.item.region_id;
      let foundRegion = null; 
      for (let i = 0; i < regions.length; i++) {
        if (regions[i].id === regionIdToFind) {
          foundRegion = regions[i];
          break;
        }
      } 

      if (foundRegion) {
        this.selectedRegion = foundRegion;
        console.log(this.selectedRegion, "selected body ");
        this.onRegionTypeChange(this.selectedRegion);
      } else {
        console.log("No matching body part found for id:", regionIdToFind);
      }
    } else {
      console.log("No bodyparts data available");
    }

    this.nameTxt = this.propData.item.name;
    this.isEdited = true;
  }
  this.renderer.listen('window', 'click', (e: Event) => {
    if (!document.querySelector('.cabinet-dropdown.stores')?.contains(e.target as Node)) {
      this.isRegionDropDown.set(false);
    }
  });
  }

  
  
  
  

  onClose(): void {
    this.dialogRef.close();
  }

  isRegionDropDown = signal(false);

  responseData: any = {};
  public fileType = "";
  public isFile = false;
  public uploadedFile: any;
  public statusType: string = "";
  public statusMessage: string = "";

  changedStoreType: any = {type: "", value: ""};
  public isDragOver = signal(false);


  dropFile(e) {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) {
      this.fileValidation(file)
    }

    this.isDragOver.set(false);
  }

  dragOverFile(e) {
    e.preventDefault();
    this.isDragOver.set(true);
  }

  dragLeaveFile(e) {
    e.preventDefault();
    this.isDragOver.set(false);
  }

  browseFile(e){
    e.preventDefault();
    let fileInput = document.getElementById("file-input");
    fileInput.click();
  }

  dragEndFile(e) {
    e.preventDefault();
    this.isDragOver.set(false);
  }

  onFileChange(event){
    event.preventDefault();
    const file = event.target.files[0];
    if (file) {
      this.fileValidation(file);
    }
  }

  fileValidation(file){
    const validFileTypes = ['csv', 'xlsx', 'xls'];
    let ext = file.name.substring(file.name.lastIndexOf('.') + 1);
    if (validFileTypes.includes(ext)) {
      this.isFile = true;
      this.uploadedFile = file;
    }else{
      this.statusType = 'error';
      this.statusMessage = `File format is invalid. Only Excel and CSV formats are allowed.`;
      this.showWarningToast();
    }
  }

  resetFile(){
    this.isFile = false;
  }

  showWarningToast(){
    const toastContainer = document.getElementById('warning-toast');

    setTimeout(function() {
      toastContainer.classList.add('show');
    }, 100);

    setTimeout(function() {
      toastContainer.classList.remove('show');
    }, 5000);
  }

  onRegionTypeChange(value:any){
      this.selectedRegion = value;
      this.isRegionDropDown.set(false); 
  } 
  onAdd(){
    let data ={
      region_id: this.selectedRegion.id,
      name: this.nameTxt
    }
    if(this.isEdited){
      this.masterdataService.masterEditBody('countries', this.propData.item.id, data).subscribe((res:any)=>{
        this.onClose();
      });
    }else{
      this.masterdataService.masterAddItem('countries',data).subscribe((res:any)=>{
        this.onClose();
      }); 
    }
  } 

}
